export const API_URL: string = 'https://api.getnovala.com';
export const FONT = "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";